import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { tabs } from 'src/app/dummy/tabs';
import { DataService } from 'src/app/services/data.service';
import { AddProgramComponent } from './add-program/add-program.component';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class ADProgramsComponent implements OnInit {
  tabs = tabs.PROGRAMS

  constructor(
    private router: Router,
    public store: List,
    public rotue: ActivatedRoute,
    public ds: DataService,
    public dialog: MatDialog,
    public auth: AuthStore,
  ) {
  }

  create(event) {
    const dialogRef = this.dialog.open(AddProgramComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }
  async ngOnInit() {
    await this.auth.fetchEnvironment()
    this.store.fetchData(this.ds.adprogramCollectRef())
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
